import * as firebase from "firebase/app";

export const getRegionName = () => {
    const projectId = firebase.app().options['projectId'];
    if (projectId === "reshub-aus-vacenti") return 'australia-southeast1'
    else if (projectId === "reshub-test" || projectId === "reshub") return 'europe-west1'
    else return 'us-central1'
}